import styled from 'styled-components';

export const ErrorLargeContainer = styled.div`
  display: flex;
  flex-direction: column;

  text-align: center;
  align-items: center;
  justify-content: center;

  gap: 24px;
  margin: 0;
  padding: 24px;

  img {
    height: 120px;
  }

  p {
    margin: 0;
    padding: 0;
    font-size: 16px;
    font-weight: 500;
  }
`;

export const ErrorSmallContainer = styled.div`
  display: flex;
  flex-direction: column;

  gap: 8px;
  margin: 0;
  padding: 16px;

  div {
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;

    gap: 8px;

    [role='img'] {
      font-size: 24px;
    }

    p {
      margin: 0;
      padding: 0;
      font-size: 16px;
      font-weight: 500;
    }
  }
`;
